import React from 'react';
import TeamCard from './TeamCard/TeamCard';
import css from './WineryTeam.module.css';
import ellipse from './ellipse.png'

function WineryTeam({team}) {
  return (
    <div className={css.wineryTeamWrapper}>
      <div className={css.wineryTeamEllipse}>
        <img src={ellipse} alt="" />
      </div>
      <div className={css.wineryTeamContainer}>
        <h1>Meet The Team</h1>
        <div className={css.wineryTeamCard}>
          {team.map((teamMember) => (
            <TeamCard  teamMember={teamMember} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default WineryTeam
